// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ballot-progress-panel-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Progress Icon in Header */
.ballot-progress-icon-fixed {
    position: relative;
    width: 42px;
    height: 42px;
    cursor: pointer;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}

.ballot-progress-icon-fixed:hover {
    transform: scale(1.05);
}

.bpp-circular-chart {
    display: block;
    width: 100%;
    height: 100%;
}

.bpp-circle-bg {
    fill: none;
    stroke: rgba(255, 255, 255, 0.1);
    stroke-width: 2.5;
}

.bpp-circle {
    fill: none;
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke: #00e0c5;
    animation: bpp-progress 1s ease-out forwards;
}

.bpp-percentage-text {
    position: absolute;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
}

/* Dropdown Panel - positioned below header icon */
.ballot-progress-dropdown {
    position: absolute;
    right: 0px;
    top: 52px;
    width: 320px;
    background: transparent;
    border-radius: 0px;
    display: flex;
    flex-direction: column;
    padding: 0px;
    box-shadow: none;
    animation: bpp-slideDown 0.3s ease;
    z-index: 101;
    border: none;
}

.bpp-panel-header {
    margin-bottom: 16px;
}

.bpp-user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    position: relative;
}

.bpp-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4a90e2, #357abd);
}

.bpp-details {
    display: flex;
    flex-direction: column;
    flex: 1 1;
}

.bpp-name {
    font-size: 13px;
    font-weight: 600;
    color: #fff;
}

.bpp-handle {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
}

.bpp-close-btn {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    transition: background 0.2s ease;
    padding: 0;
}

.bpp-close-btn:hover {
    background: rgba(255, 255, 255, 0.1);
}

.bpp-card {
    background: #0e1b1b;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 0px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.bpp-card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

.bpp-card-top .highlight {
    color: #00e0c5;
    font-size: 14px;
}

.bpp-bar-container {
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 10px;
}

.bpp-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #00e0c5 0%, #00a896 100%);
    border-radius: 3px;
    transition: width 1s ease;
}

.bpp-card-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.6);
}

.bpp-card-bottom .highlight {
    color: #00e0c5;
}

.bpp-menu {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.bpp-menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.4);
    font-size: 12px;
    transition: all 0.2s ease;
}

.bpp-menu-item.active {
    background: rgba(0, 224, 197, 0.1);
    border-color: rgba(0, 224, 197, 0.3);
    color: #00e0c5;
    font-weight: 600;
}

.bpp-menu-item:hover {
    background: rgba(255, 255, 255, 0.05);
}

.bpp-menu-item.active:hover {
    background: rgba(0, 224, 197, 0.15);
}

@keyframes bpp-fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes bpp-slideDown {
    from {
        transform: translateY(-10px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes bpp-slideLeft {
    from {
        transform: translateX(10px);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes bpp-progress {
    0% {
        stroke-dasharray: 0 100;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/BallotProgressPanel/BallotProgressPanel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,4DAA4D;IAC5D,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".ballot-progress-panel-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Progress Icon in Header */\n.ballot-progress-icon-fixed {\n    position: relative;\n    width: 42px;\n    height: 42px;\n    cursor: pointer;\n    z-index: 100;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: transform 0.2s ease;\n    flex-shrink: 0;\n}\n\n.ballot-progress-icon-fixed:hover {\n    transform: scale(1.05);\n}\n\n.bpp-circular-chart {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.bpp-circle-bg {\n    fill: none;\n    stroke: rgba(255, 255, 255, 0.1);\n    stroke-width: 2.5;\n}\n\n.bpp-circle {\n    fill: none;\n    stroke-width: 2.5;\n    stroke-linecap: round;\n    stroke: #00e0c5;\n    animation: bpp-progress 1s ease-out forwards;\n}\n\n.bpp-percentage-text {\n    position: absolute;\n    font-size: 10px;\n    font-weight: 700;\n    color: #fff;\n}\n\n/* Dropdown Panel - positioned below header icon */\n.ballot-progress-dropdown {\n    position: absolute;\n    right: 0px;\n    top: 52px;\n    width: 320px;\n    background: transparent;\n    border-radius: 0px;\n    display: flex;\n    flex-direction: column;\n    padding: 0px;\n    box-shadow: none;\n    animation: bpp-slideDown 0.3s ease;\n    z-index: 101;\n    border: none;\n}\n\n.bpp-panel-header {\n    margin-bottom: 16px;\n}\n\n.bpp-user-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 10px;\n    position: relative;\n}\n\n.bpp-avatar {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #4a90e2, #357abd);\n}\n\n.bpp-details {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.bpp-name {\n    font-size: 13px;\n    font-weight: 600;\n    color: #fff;\n}\n\n.bpp-handle {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.bpp-close-btn {\n    background: transparent;\n    border: none;\n    color: #fff;\n    font-size: 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    transition: background 0.2s ease;\n    padding: 0;\n}\n\n.bpp-close-btn:hover {\n    background: rgba(255, 255, 255, 0.1);\n}\n\n.bpp-card {\n    background: #0e1b1b;\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 0px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.bpp-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n    color: #fff;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.bpp-card-top .highlight {\n    color: #00e0c5;\n    font-size: 14px;\n}\n\n.bpp-bar-container {\n    height: 6px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 3px;\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n.bpp-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #00e0c5 0%, #00a896 100%);\n    border-radius: 3px;\n    transition: width 1s ease;\n}\n\n.bpp-card-bottom {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.bpp-card-bottom .highlight {\n    color: #00e0c5;\n}\n\n.bpp-menu {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.bpp-menu-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 14px;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 10px;\n    color: rgba(255, 255, 255, 0.4);\n    font-size: 12px;\n    transition: all 0.2s ease;\n}\n\n.bpp-menu-item.active {\n    background: rgba(0, 224, 197, 0.1);\n    border-color: rgba(0, 224, 197, 0.3);\n    color: #00e0c5;\n    font-weight: 600;\n}\n\n.bpp-menu-item:hover {\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.bpp-menu-item.active:hover {\n    background: rgba(0, 224, 197, 0.15);\n}\n\n@keyframes bpp-fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes bpp-slideDown {\n    from {\n        transform: translateY(-10px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes bpp-slideLeft {\n    from {\n        transform: translateX(10px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n@keyframes bpp-progress {\n    0% {\n        stroke-dasharray: 0 100;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
